module.exports = __webpack_public_path__ + "img/268-2.fd47ab7e.png";